import React from 'react'

import { useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import { useDialogStore } from '@stores/dialog.store'

import EditScoreDetailsDialog from './EditScoreDetailsDialog'

const EditScoreDetailsButton: React.FC = () => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)

  return (
    <>
      <Button
        variant="primary"
        onClick={() => openDialog('edit_score_details')}
        className="text-md py-1.5 px-3 flex flex-row items-center justify-center">
        {t('action.editScore')}
      </Button>
      <EditScoreDetailsDialog />
    </>
  )
}

export default EditScoreDetailsButton
